import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';
import { Event as EventService } from '../services/event';
import { NetworkService } from '../services/network';

/**
 * Accès à la FICHE détail d'un événement. Autorisé si la fiche est LISIBLE par
 * l'appelant — la lecture délègue l'autorisation aux règles Firestore : succès
 * pour un membre, le gestionnaire, un admin OU un événement public (aperçu
 * non-membre). Un événement privé dont on n'est pas membre lève une erreur →
 * redirection /home. event-detail gère ensuite l'affichage membre vs aperçu.
 *
 * Distinct de `eventMemberGuard`, qui reste strict sur les espaces sensibles
 * (contributions, dépenses, chat, retraits, groupes).
 */
export const eventViewGuard: CanActivateFn = async (route) => {
  const auth = inject(Auth);
  const eventService = inject(EventService);
  const router = inject(Router);
  const network = inject(NetworkService);

  // Attendre la restauration de session (cold reload) avant toute lecture Firestore.
  await auth.authReady;

  const eventId = route.paramMap.get('eventId');
  if (!eventId) return router.createUrlTree(['/home']);

  try {
    const event = await eventService.getEventOnce(eventId);
    return event ? true : router.createUrlTree(['/home']);
  } catch {
    // Offline: allow navigation — Firestore cache may serve the data
    if (!network.isOnline()) return true;
    return router.createUrlTree(['/home']);
  }
};
